import { usePlatformConfig } from "@aurem/components";
import { Button, Text } from "@aurem/ui";
import { AuthContainer } from "components/AuthContainer";
import { useAcceptInvitation } from "hooks/useAcceptInvitation";
import { AuthStatus, useAuth } from "providers/AuthProvider";
import { useI18n } from "providers/I18nProvider";
import { useEffect } from "react";
import {
  Navigate,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import ROUTES from "../../../const/routes";

export const LandingPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { language } = useParams();
  const config = usePlatformConfig();
  const { loading, invitation } = useAcceptInvitation();
  const { t } = useI18n();
  const { authState } = useAuth();

  const invitationType = params.get("type") || "employee";

  if (authState.status === AuthStatus.Authenticated) {
    const targetApp = invitationType === "employee" ? "employee" : "admin";
    return <Navigate to={`/${language}/${targetApp}`} replace />;
  }

  const platform = invitationType === "admin" ? "admin" : "employee";

  const handleNavigate = (path: string) => {
    void navigate({
      pathname: path,
      search: params.toString(),
    });
  };

  const getSignUpRoute = () => {
    return invitationType === "employee"
      ? `/${ROUTES.SIGN_UP_EMPLOYEE}`
      : `/${ROUTES.SIGN_UP_NEW_COMPANY_ADMIN}`;
  };

  useEffect(() => {
    if (!loading && !invitation) {
      void navigate({
        pathname: `/${ROUTES.SIGN_IN}`,
        search: "invalidInvitation=true",
      });
    }
  }, [loading, invitation]);

  if (loading || !invitation) {
    return null;
  }
  return (
    <AuthContainer platform={platform}>
      <div>
        <Text size="2xl" weight="medium">
          {t("apps.employee.pages.landing.page.welcome", config.name)}
        </Text>
        <Text size="md" className="mt-2">
          {t("apps.employee.pages.landing.page.description")}
        </Text>
      </div>
      <section className="flex flex-col gap-2">
        <Button
          className="w-full mt-4"
          onClick={() => handleNavigate(getSignUpRoute())}
        >
          {t("apps.employee.pages.landing.page.getStarted")}
        </Button>
        <Button
          variant="outlined"
          color="neutral"
          onClick={() => handleNavigate(`/${ROUTES.SIGN_IN}`)}
        >
          {t("apps.employee.pages.landing.page.alreadyHaveAccount")}
        </Button>
      </section>
    </AuthContainer>
  );
};
